import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { redirect } from '@app/guards/feature-guards/helpers';
import { JobPosting } from '@app/models/recruiting/job-posting.model';

@Injectable()
export class DraftJobPostingRedirectGuard {
    constructor(private readonly router: Router) {}

    async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
        const jobPosting = await JobPosting.find(_route.paramMap.get('jobPosting'));
        if (!jobPosting.isDraft) {
            return true;
        }

        redirect(this.router, { jobPostingId: jobPosting.id }, ['/recruiting', 'jobPostings', 'create']);
    }
}
